import { render, staticRenderFns } from "./CropperImg.vue?vue&type=template&id=4c616cb9&scoped=true"
import script from "./CropperImg.vue?vue&type=script&lang=js"
export * from "./CropperImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c616cb9",
  null
  
)

export default component.exports